<template>
  <div class="main">
    <v-app-bar
      app
      clipped-left
      :color="appBarColor"
      dark
      dense
    >
      <v-icon>fa-charging-station</v-icon>
      <v-spacer />
      <v-app-bar-title class="mx-3">
        Quanticy
      </v-app-bar-title>
      <v-spacer />
      <!-- admin client selection -->
      <v-col col="1">
        <v-autocomplete
          v-if="user.hasOwnProperty('clients')"
          dense
          :items="user.clients"
          :item-text="item => item.name"
          :item-value="item => item"
          @change="updateSelectedClient($event)"
        />
      </v-col>
      <v-spacer v-if="user.hasOwnProperty('clients')" />
      <v-badge
        color="warning"
        icon="fa-star"
        overlap
        bottom
        left
      >
        <v-btn
          icon
          @click="localShepherdTour()"
        >
          <v-icon>fa-info</v-icon>
        </v-btn>
      </v-badge>
      <questionnaire
        ref="questionnaire"
        :auto-open="autoOpenQuestionnaire"
        @resetAutoOpen="autoOpenQuestionnaire = false;"
      />
      <template v-if="userLoggedIn">
        <user-settings 
          @user-settings-updated="handleUserSettingsUpdated"
        />
      </template>
      <license-info-dialog />
      <v-btn
        id="test"
        icon
        @click="performLogout()"
      >
        <v-icon>fa-sign-out-alt</v-icon>
      </v-btn>
    </v-app-bar>

    <Map
      :update-id="updateId"
      :ags-id="agsId"
      :point-layer-types="pointLayerTypes"
      :geo-input-types="geoInputTypes"
    />
    <MapMenu />
  </div>
</template>

<script>
"use strict";
// @ is an alias to /src
import Map from "@/components/Map.vue";
import MapMenu from "@/components/MapMenu.vue";

import { shepherdTour } from "./../plugins/shepherd";

import { mapActions, mapGetters, mapMutations } from "vuex";
import UserSettings from "../components/dialogs/UserSettings.vue";
import Questionnaire from "../components/dialogs/Questionnaire.vue";
import LicenseInfoDialog from "../components/dialogs/LicenseInfoDialog.vue";

const cookie = require('cookie');

export default {
  name: "Main",
  components: {
    Map,
    MapMenu,
    UserSettings,
    Questionnaire,
    LicenseInfoDialog
  }, 
  data() {
    return {
      autoOpenQuestionnaire: false,
      shepherdTour: null
    }
  },
  computed: {
    ...mapGetters([
      "ags",
      "updates",
      "updatesFilteredByAgs",
      "selectedAgs",
      "selectedUpdate",
      "user"
    ]),
    // TODO: refactor these four computed vars:
    // retrieve them directly from state and get rid of passing Map props
    agsId() {
      return this.selectedAgs ? this.selectedAgs.agsId : null;
    },
    updateId() {
      return this.selectedUpdate ? this.selectedUpdate.updateId : null;
    },
    pointLayerTypes() {
      return this.$store.state.pointLayerTypes;
    },
    geoInputTypes() {
      return this.$store.state.geoInputTypes;
    },
    userLoggedIn() {
      return this.$store.state.user.name !== null;
    },
    appBarColor() {
      if (this.selectedUpdate) {
        if (this.selectedUpdate.updateStatus == "editing") {
          return "#8B008B";
        } else if (
          this.selectedUpdate.updateStatus == "ready_for_calculation" ||
          this.selectedUpdate.updateStatus == "now_calculating"
        ) {
          return "grey";
        }
      }
      return "blue";
    }
  },
  beforeDestroy() {
    this.unsetUser();
  },
  async created() {
    window.EventBus.$on("NotAuthenticated", (licenseExpired, license) => {
      this.unsetUser();
      if (this.$router.currentRoute.path != "/login") {
        this.$router.push("/login");
      }
      if (licenseExpired) {
        this.$nextTick(() => {
          window.EventBus.$emit("licenseExpired", license);
        })
      }
    });
  },
  async mounted() {
    // Ensure user is logged in. In all other cases bring her back to login page.
    let licenseExpired = false;
    let user = null;
    await $api
      .get("auth/checklogin")
      .then(res => {
        if (res.data.authenticated === true) {
          console.log("User has been authenticated before.");
          this.setUser(res.data.user);
        } else {
          user = res.data.user;
          licenseExpired = !!res.data.licenseExpired;
          throw "res.data.authentication not true";
        }
      })
      .catch(error => {
        console.error(error);
        console.log("User has not been authenticated yet -> Login.");
        this.performLogout(licenseExpired, user?.license);
      });
      
    await this.retrieveAgs();
    this.retrieveUpdates();
    // Start the tutorial after login if user has not finished it or wants to see it again.
    this.checkForShepherdTourStart(); 
    window.EventBus.$on("reloadUpdates", () => this.retrieveUpdates());
    window.EventBus.$on("reloadAgs", () => this.retrieveAgs());
    window.EventBus.$on("runShepherd", () => this.localShepherdTour());
    window.EventBus.$on("performLogout", () => this.performLogout());
    window.EventBus.$on("checkForShepherdTourStart", () => this.checkForShepherdTourStart());
  },
  methods: {
    ...mapActions([
      "unsetUser",
      "setSelectedUpdate",
      "setSelectedAgs",
      "setSelectedYearIndex",
      "setUpdates",
      "setAgs"
    ]),
    ...mapMutations([
      "setUser",
      "nextStep"
    ]),
    checkForShepherdTourStart() {
      if (
        cookie.parse(document.cookie).hideCookieBanner == "true" &&
      (!Object.prototype.hasOwnProperty.call(
        this.user.metadata,
        "shepherd"
      ) ||
          this.user.metadata.shepherd.show) &&
          this.ags.length != 0
            
      ) {
        this.localShepherdTour();
      }
    },
    localShepherdTour() {
      if(this.shepherdTour === null || !this.shepherdTour?.isActive()){
        this.$store.commit("resetSelectedAgs")
        this.$store.commit("resetSelectedUpdate")

        this.shepherdTour = shepherdTour();
      }
    },
    // Get ags that can be accessed by client.
    retrieveAgs() {
      return $api.get(`ags?client_id=${this.user.clientId}`).then(res => {
        if (res.data.ags.length == 0) {
          // automatically open questionnaire if there are no ags for this client
          this.autoOpenQuestionnaire = true;
        }
        this.setAgs(res.data.ags);
      });
    },
    // Get updates that can be accessed by client.
    retrieveUpdates() {
      $api.get(`update?client_id=${this.user.clientId}`).then(res => {
        this.setUpdates(res.data.updates);
      });
    },
    performLogout(licenseExpired, license) {
      $api.get("auth/logout").then(res => {
        if (res.data.authenticated === false) {
          // this.authenticated = false;
          window.EventBus.$emit("NotAuthenticated", licenseExpired, license);
        }
      });
    },
    handleUserSettingsUpdated(){
      if(this.ags.length < 1) {
        this.$refs.questionnaire.dialogQuestionnaire = true
      }
    },
    async updateSelectedClient(selectedClient) {
      let user={};
      user.license = selectedClient.license;
      user.clientName = selectedClient.name
      user.clientId =selectedClient.id
      this.setUser(user);
      await this.retrieveAgs();
      this.retrieveUpdates();
    }
  }
};
</script>

<style lang="scss">
@import "~shepherd.js/dist/css/shepherd.css";

.main {
  height: 100%;
}

.quanticy-shepherd-tour {
  width: 400px;

  &.welcome-shepherd {
    width: 500px;
  }

  & .shepherd-content {
    position: relative;

    & .shepherd-header {
      width: 26px;
      height: 26px;
      margin: 0;
      padding: 0;

      position: absolute;
      top: -10px;
      right: -13px;

      width: max-content;
      height: max-content;
      background: transparent;

      & .shepherd-cancel-icon {
        position: relative;
        height: 26px;
        width: 26px;
        left: 0px;
        top: 0px;
        border-radius: 50%;

        background: #2196f3;
        box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.08),
          0px 4px 14px rgba(0, 0, 0, 0.03);

        & span {
          color: #fff;
          line-height: 25px;
          font-size: 25px;

          position: absolute;
          top: -1px;
          left: 6px;
        }
      }
    }

    & .shepherd-text {
      padding: 15px 20px;
    }

    & .sh-heading {
      font-family: "Roboto", sans-serif;
      font-size: 18px;
      line-height: 26px;

      color: #000;
    }

    & .sh-text {
      font-family: "Roboto", sans-serif;
      font-size: 14px;
      line-height: 20px;

      color: #000;
    }

    & .shepherd-footer {
      display: grid;

      grid-template-columns: 1fr 25px 25px;

      align-items: center;

      padding: 12px 15px 12px 20px;

      background: #2196f3;

      & #shepher-progress-dots {
        display: flex;
        gap: 7px;
        align-items: center;
        
        &  > div {
          cursor: pointer;
        }
      }

      & .shepherd-button {
        width: max-content;
        height: max-content;

        background: transparent;

        display: grid;
        place-items: center;

        padding: 0;
        color: #fff;

        & :hover {
          opacity: 0.5;
        }
      }
    }
  }
}
</style>
